import { render } from "./sendForDeliveryDialog.vue?vue&type=template&id=fb54863e"
import script from "./sendForDeliveryDialog.vue?vue&type=script&lang=js"
export * from "./sendForDeliveryDialog.vue?vue&type=script&lang=js"

import "./sendForDeliveryDialog.vue?vue&type=style&index=0&id=fb54863e&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__